export default {"src":"/_next/static/media/status.4ac4c84a.svg","height":256,"width":352,"blurWidth":0,"blurHeight":0};